import Swal from 'sweetalert2';
import React, { useState } from 'react';

import { ActionButton } from './ActionButton';
import { useShowNotification } from '../../../hooks/useShowNotification';

export const ConfirmationActionButton = (props) => {
    const [isLoading, setIsLoading] = useState(false);

    const { notificationTitle, notificationIcon } = props;
    const showNotification = useShowNotification(notificationTitle, notificationIcon);

    const { onSucceed, onFailed, action } = props;

    const handleAction = async () => {
        try {
            const result = await Swal.fire({
                icon: 'question',
                title: 'Are you sure?',
                text: confirmationText,
                confirmButtonText: 'Yes, continue',
                cancelButtonText: 'No, cancel',
                confirmButtonClass: 'btn btn-primary mb-3',
                cancelButtonClass: 'btn btn-secondary ms-2 mb-3',
                showCancelButton: true,
                buttonsStyling: false
            });

            if (!result.isConfirmed) {
                setIsLoading(false);
                return;
            }

            const response = await action();
            setIsLoading(false);

            if (!response.success) {
                showNotification(response.message, 'warning');
                handleFail(response);
                return;
            }

            showNotification(response.message, 'success');
            handleSuccess(response);
        } catch (error) {
            handleFail(error);
            setIsLoading(false);
        }
    };

    const handleSuccess = (response) => {
        if (onSucceed) {
            onSucceed(response);
        }
    };

    const handleFail = (error) => {
        if (onFailed) {
            onFailed(error);
        }
    };

    const { confirmationText, tooltipText, children, className } = props;

    return (
        <ActionButton
            tooltipText={tooltipText}
            onClick={handleAction}
            className={`${className}`}
            disabled={isLoading}>
            {children}
        </ActionButton>
    );
};
